import React from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {AbandonFlowModalProps} from './types';

const {goBack, confirm} = translations['pt-br'].commons;

function AbandonFlowModal({
	open,
	setOpen,
	handleConfirm,
	headerTitle,
	description,
	title,
	confirmButtondataTagId,
	backButtondataTagId,
	closeButtondataTagId,
	modaldataTagId,
	customIconName,
	subDescription,
}: AbandonFlowModalProps) {
	function handleClose() {
		setOpen(false);
	}

	return (
		<AlertModal
			headerDataTagId={modaldataTagId}
			closeBtnDataTagId={closeButtondataTagId}
			customIconName={customIconName}
			footerContent={
				<AlertActions
					primaryAction={handleConfirm}
					secondaryAction={handleClose}
					secondaryText={goBack}
					primaryText={confirm}
					dataTagId={confirmButtondataTagId}
					secondaryBtnDataTagId={backButtondataTagId}
				/>
			}
			description={description}
			headerTitle={headerTitle}
			title={title}
			open={open}
			onClose={handleClose}
			variant="primary"
			subDescription={subDescription}
		/>
	);
}

export {AbandonFlowModal};
